import React from "react"

import { RichTextContent } from "../Styled/Text"

import { withRichText } from "./withRichText"

export const RichText = withRichText(({ children }) => <RichTextContent>{children}</RichTextContent>)
